import "../App.css";
import "../general.css";
import "../queries.css";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";

import Seo from "../components/SEO"
import { useFacebookPageView } from "../hook/useFacebookPageView";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,

  faReddit,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelopeCircleCheck } from "@fortawesome/free-solid-svg-icons";

import indiegogo from "../assets/images/IGG_Logo_Wordmark_White_RGB-01.png";

function Join() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/join", title: "join to the community page" });
  }, []);

  useFacebookPageView();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    console.log(windowWidth);
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);

  return (
    <motion.main
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
    <Seo
      title="Be a Rouser - Join to our taboo free community"
      description="We’re not selling sugar water with a logo — we’re building a sex-positivity movement that actually matters. People are stressed, disconnected, and tired of pretending. We want to bring back real intimacy — without shame, without pressure. #keepgoing"
      url="https://therouseco.com/join"
      keywords={["rouse", "intimacy drink", "hydration", "natural energy", "libido"]}
      uploadDate="2025-07-09"
      includeVideoSchema={false}
    />

      <section className="section-join" id="join" style={{ paddingTop: "30px" }}>
        <div className="form-div">
          <div
            className="join-text info-text small-text"
            style={{ color: "white" }}
          >
            <div
              className="heading-primary subheading drawn"
              style={{
                padding: "0px 40px",
                margin: "0",
                color: "white",
                marginTop: "20px",
                lineHeight: "50px",
              }}
            >
              Free Yourself
            </div>
            <div
              className=""
              style={{
                padding: "0px 0px",
                margin: "0",
                color: "white",
                marginTop: "80px",
                display: "flex",
                width: "100%",
                fontWeight: "600",
              }}
            >
              Join to the community
            </div>
            <p className="">
              If you are aroused and ready for a ride with the hot sexy…
              taboo-free intimacy or just simply would stay informed about our
              progress, please use the buttons below to join one of our
              channels. <sup style={{fontWeight:"200"}}>*, **</sup>
            </p>
            <ul className="social-links-lg">
              <li>
                <a
                  href="https://www.instagram.com/rouse_drink"
                  className="social-link-lg"
                  target="_BLANK"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    className="social-icon-lg md hydrated"
                    icon={faInstagram}
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://whatsapp.com/channel/0029VaKsCii4IBhCjjaX9F2w"
                  className="social-link-lg"
                  target="_BLANK"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    className="social-icon-lg md hydrated"
                    icon={faWhatsapp}
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.reddit.com/r/rousedrink/"
                  className="social-link-lg"
                  target="_BLANK"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    className="social-icon-lg md hydrated"
                    icon={faReddit}
                  />
                </a>
              </li>
              <li>
                <a
                  href="/subscribe#"
                  className="social-link-lg"
                  target="_BLANK"
                >
                  <FontAwesomeIcon
                    className="social-icon-lg md hydrated"
                    icon={faEnvelopeCircleCheck}
                  />
                </a>
              </li>
            </ul>
            <p>
              If you'd like more than a good friendship… participate in product
              development or gain access to exclusive contents, consider
              supporting us on Indiegogo in order to expedite our 'F*** the market'
              quest. <sup style={{fontWeight:"200"}}>*, **</sup>
            </p>
            <div style={{ display: "flex", verticalAlign: "middle", margin: "auto", paddingTop: "2.4rem" }}>
            <div  id="b8"
                  className="button button-join-patreon"
                  >
                  <a href="https://www.indiegogo.com/projects/f-it-first-rehydration-drink-for-sex-by-rouse/reft/38212726/website" target="_blank" rel="noopener noreferrer">
                    <img className="" style={{maxHeight:"60%", maxWidth:"60%"}} src={indiegogo} alt="" />
                  </a>
                </div>
              
            </div>
            <p
              style={{
                fontSize: "1.2rem",
                fontStyle: "italic",
                lineHeight: "1.5rem",
                marginTop: "2.4rem",
              }}
            >
              * By liking, following and subscribing to our news letter, Facebook pages,
              Indiegogo page, Instagram sites and channel, Whatsapp channels or
              Reddit channels, you acknowledge and agree our Private policy
              included in Terms and conditions. For the details please check our
              Terms and conditions.
            </p>
            <p
              style={{
                fontSize: "1.2rem",
                fontStyle: "italic",
                lineHeight: "1.5rem",
                marginTop: "-10px",
                paddingTop: "0",
              }}
            >
              ** By liking, following and subscribing to our news letter, Facebook pages,
              Indiegogo page, Instagram sites and channel, Whatsapp channels or
              Reddit channels, you acknowledge and agree that The Rouse Co. may
              engage in sales and marketing activities through those. For the
              details please check our Terms and conditions.
            </p>
          </div>
        </div>
      </section>
    </motion.main>
  );
}

export default Join;
